import React from "react";
import './Home.css'
import "../App.css";
import './Services.css'
import Service from "./Service";
const servicesData = [
  {
    title: "General Medicine",
    desc: "Preventive & chronic disease care for all ages.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "General & Laparoscopic Surgery",
    desc: "Minimally invasive procedures with faster recovery.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "24×7 Accident, Emergency & Trauma Care",
    desc: "Round-the-clock urgent care with advanced ICU.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Orthopedics & Joint Replacement",
    desc: "Expert bone, joint & spine treatments.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Physiotherapy & Rehabilitation",
    desc: "Post-surgery recovery & chronic condition support.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "Urology & Nephrology",
    desc: "Kidney & urinary tract treatments with dialysis services.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "Oncology",
    desc: "Comprehensive cancer care & chemotherapy.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Neurology & Neurosurgery",
    desc: "Brain, spine & nerve disorder treatments.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "Gynecology & Obstetrics",
    desc: "Prenatal care, high-risk deliveries & advanced surgeries.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "Pediatrics & Neonatal Care",
    desc: "Specialized care for infants & children.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Psychiatry & Mental Health",
    desc: "Counseling & treatment for mental health conditions.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "Dermatology & Skin Care",
    desc: "Skin treatments, cosmetic & laser therapies.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "Burns, Plastic & Reconstructive Surgery",
    desc: "Advanced surgical care & aesthetic restoration.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Corporate Health Check-ups",
    desc: "Tailored preventive programs & wellness camps.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "Pathology & Diagnostic Services",
    desc: "Accurate & timely lab investigations.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "Advanced Radiology Imaging",
    desc: "X-ray, MRI, CT Scan & Ultrasound services.",
    img: "assets/img/all-images/service/service-img19.png",
  },
];

function Services() {
  return (
    <>
         { /*===== HERO AREA STARTS =======*/ }
<div className="inner-header-section-area" style={{ backgroundImage: "url(assets/img/all-images/bg/BG-Orange-shade.png)", backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
  <img src="assets/img/elements/elements28.webp" alt="" className="elements28" />
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-12">
        <div className="hero-header">
          <h1 className="text-anime-style-1">Service</h1>
          <div className="space28" />
          <a href="index.html" className="bradecrumb">Home <i className="fa-solid fa-angle-right" />Service</a>
        </div>
      </div>
    </div>
  </div>
</div>
<Service/>
{ /*===== HERO AREA ENDS =======*/ }
    </>
    
  );
}

export default Services;
